import React, { useState } from 'react';

import colors from 'utils/colors';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const Tabs: React.FC<ComponentProps> = ({ items = [], defaultActiveIndex = 0 }) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);

  return (
    <Styled.Wrapper>
      <Styled.Tabs role='tablist'>
        {items.map((item, index) => (
          <Styled.TabItem
            role='tab'
            key={item.id}
            data-testid={`${item.id}-Tabs`}
            onClick={() => setActiveIndex(index)}
            active={activeIndex === index}
            aria-selected={activeIndex === index}>
            <Styled.Header>
              <Styled.ArrowIcon fill={activeIndex === index ? colors.orange : colors.blueGrey} />
              <Styled.Title>{item.title}</Styled.Title>
            </Styled.Header>
          </Styled.TabItem>
        ))}
      </Styled.Tabs>
      <Styled.Content role='tabpanel'>{items[activeIndex].component}</Styled.Content>
    </Styled.Wrapper>
  );
};

export default Tabs;
